import { EyeOutlined } from '@ant-design/icons';
import { type ArchivedSubmissionDto } from '@framework/api-client';
import { t } from '@framework/i18n';
import { generatePath, ISODate, Link, TableCellEllipsis } from '@framework/ui';
import { Tag, Tooltip } from 'antd';
import { type ColumnType } from 'antd/es/table';
import styled from 'styled-components';

export const ArchivedStateTag = styled(Tag)`
  border-radius: 2px;
  letter-spacing: 0.03em;

  &&& {
    font-weight: 600;
  }
`;

export const archivedSubmissionColumns: Array<
  ColumnType<ArchivedSubmissionDto>
> = [
  {
    key: 'state',
    dataIndex: 'state',
    title: t('archived-submissions.state', 'Stato'),
    width: 120,
    render: text => (
      <ArchivedStateTag color="magenta-inverse">
        {t(`archived-submissions.status`, 'ARCHIVIATA')}
      </ArchivedStateTag>
    ),
  },
  {
    key: 'protocolSignature',
    dataIndex: 'protocolSignature',
    sorter: true,
    title: t('archived-submissions.protocol-signature', 'Numero Protocollo'),
    width: 120,
  },
  {
    key: 'subject',
    dataIndex: 'subject',
    title: t('archived-submissions.columns.subject', 'Oggetto'),
    render: text => (
      <TableCellEllipsis
        children={text}
        tooltip={false}
        width={600}
        // expandable={false}
      />
    ),
  },
  {
    key: 'sentAt',
    dataIndex: 'sentAt',
    sorter: true,
    title: t('archived-submissions.sent-at', 'Data Invio'),
    width: 120,
    render: date => <ISODate date={date} />,
  },
  {
    key: 'actions',
    align: 'right',
    fixed: 'right',
    title: (
      <span className="sr-only">
        {t('submission-list.header-col.actions', 'Azioni')}
      </span>
    ),
    width: 60,
    render: (text, record) => (
      <Link
        title={t(
          'archived-submissions.columns.see-details-text',
          'Apri la pagina di dettaglio della richiesta',
        )}
        to={generatePath('/richieste/archiviate/:id', {
          id: record.id.toString(),
        })}
      >
        <Tooltip
          title={t(
            'archived-submissions.columns.see-details-tooltip',
            'Visualizza richiesta',
          )}
        >
          <EyeOutlined
            aria-label={t(
              'archived-submissions.columns.see-details-tooltip',
              'Visualizza richiesta',
            )}
          />
        </Tooltip>
      </Link>
    ),
  },
];
